import { useSelect } from "@wordpress/data";
import { useState, useEffect } from "@wordpress/element";

export default function flat_tabbed_docs({ attributes, docSections, articlesNumber, multiDocs }) {
    const { readMoreText, child_docs_order, orderBy, isFeaturedImage } = attributes;

    // State for active tab
    const [activeTab, setActiveTab] = useState(null);

    // Fetch all documents (both parents and children)
    const allDocs = useSelect(
        (select) =>
            select("core").getEntityRecords("postType", "docs", {
                per_page: -1, // Fetch all documents
                status: ["publish", "private"],
                order: child_docs_order, // Specify order: 'asc' or 'desc'
                orderby: orderBy, // Specify field to order by, e.g., 'menu_order', 'date', 'title'
            }),
        [child_docs_order, orderBy]
    );

    useEffect(() => {
        if (docSections && docSections.length > 0) {
            // Set the first section as the default active tab
            setActiveTab(docSections[0].id);
        } else if (multiDocs && multiDocs.length > 0) {
            // Set the first multiDoc as the default active tab if docSections is empty
            setActiveTab(multiDocs[0].id);
        }
    }, [docSections, multiDocs]);

    if (!allDocs) return <p>Loading...</p>;
    if (allDocs.length === 0) return <p>No documents found.</p>;

    // Separate parent and child documents
    const mainDocs = allDocs.filter((doc) => doc.parent === 0);  // Parent docs are those with parent === 0
    const getChildDocs = (parentId) => allDocs.filter((doc) => doc.parent === parentId);  // Children are filtered by parentId
    
    // Function to show first 'n' words of a sentence
    const showWords = (sentence, numberOfWords) => {
        // Split the sentence into an array of words
        let wordsArray = sentence.split(" ");

        // If the number of words to show is greater than the length of the array, return the original sentence
        if (numberOfWords >= wordsArray.length) {
            return sentence;
        }

        // Slice the array to get the desired number of words and join them back into a string
        let truncatedSentence = wordsArray.slice(0, numberOfWords).join(" ");

        // Return the truncated sentence
        return truncatedSentence;
    };

    function FeaturedImage({ mediaId, title }) {
        const [imageUrl, setImageUrl] = useState("");
    
        useEffect(() => {
            if (mediaId) {
                wp.apiFetch({ path: `/wp/v2/media/${mediaId}` })
                    .then((media) => setImageUrl(media.source_url))
                    .catch((error) => console.error("Error fetching media:", error));
            }
        }, [mediaId]);
    
        return imageUrl ? <img className="doc-logo" src={imageUrl} /> : null;
    }
    
    return (
        <section class="h_doc_documentation_area" id="Arrow_slides-bada9fe">
            
            <div class="tabs_sliders">
                <span class="scroller-btn left inactive"><i class="arrow_carrot-left"></i></span>
                
                <ul class="nav nav-tabs documentation_tab ezd-tab-menu slide_nav_tabs ezd-list-unstyled">
                    {(docSections || multiDocs) &&
                        [...(docSections || []), ...(multiDocs || [])].map((section) => {
                            const { id, title, excerpt, slug } = section;

                            return (
                                <li class="nav-item" key={id}>
                                    
                                    <a
                                        data-rel={slug}
                                        className={`nav-link ezd_tab_title ${
                                            activeTab === id ? "active" : ""
                                        }`}
                                        onClick={() => setActiveTab(id)}
                                    >
                                        {title.rendered}
                                    </a>
                                </li>
                            );
                        })
                    }
                </ul>
                <span class="scroller-btn right inactive"><i class="arrow_carrot-right"></i></span>
            </div>

            <div class="ezd-tab-content">
        
                {(docSections || multiDocs) &&
                [...(docSections || []), ...(multiDocs || [])].map((section) => {
                    const {  excerpt, featured_media } = section;
                    // Get child docs for this section
                    // const childDocs = getChildDocs(section.id);
                    const childDocs = getChildDocs(section.id).slice(0, articlesNumber);
                    return (
                        <div
                            className={`documentation_tab_pane ezd-tab-box ${
                                activeTab === section.id ? "active" : ""
                            }`}
                            id={section.slug}
                            key={section.id}
                        >

                        <div class="ezd-grid ezd-grid-cols-12">                           
                        
                            <div class="ezd-lg-col-4 ezd-grid-column-full">
                                <div class="documentation_text">

                                    
                                    {isFeaturedImage && (
                                        <FeaturedImage mediaId={featured_media} title={section.title.rendered} />
                                    )}

                                    <h4 class="ezd_item_parent_title">{section.title.rendered}</h4>
                                    <p class="ezd_item_content">
                                        {showWords(section.excerpt.rendered.replace("<p>", "").replace("</p>", ""), 15)}
                                    </p>
                                    {readMoreText && (                               
                                    <a href="" class="learn_btn ezd_btn">
                                        {readMoreText} <i className="arrow_right"></i>
                                    </a>
                                    )}
                                </div>
                            </div>
                            
                            <div class="ezd-lg-col-8 ezd-grid-column-full">
                            <div class="d-items">
                            
                            {childDocs.map((childDoc) => {
                                const { featured_media } = childDoc;
                                return (
                                    <div className="media documentation_item" key={childDoc.id}>
                                        <div className="icon bs-sm">
                                            {isFeaturedImage && featured_media ? (
                                                <FeaturedImage mediaId={featured_media} title={childDoc.title.rendered} />
                                            ) : (
                                                <img
                                                    decoding="async"
                                                    src="https://wordpress-plugins.spider-themes.net/checker/wp-content/plugins/eazydocs/includes/Elementor/Docs/images/folder.png"
                                                    alt="Getting Started"
                                                />
                                            )}
                                        </div>

                                        <div className="media-body">
                                            <a href="#">
                                                <h5 className="title ezd_item_title">{childDoc.title.rendered}</h5>
                                            </a>
                                            <p className="ezd_item_content">
                                                {showWords(childDoc.excerpt.rendered.replace("<p>", "").replace("</p>", ""), 10)}
                                            </p>
                                        </div>
                                    </div>
                                );
                            })}

                                
                            </div>
                            </div>
                        </div>
                    </div>
                    
                );
            })}

        </div>
</section>
    );
}
